import $ from 'jquery';

export default function search() {
  
  function showSearch() {
    var searchBox = $('.search__form');
		var submitIcon = $('.search__icon');
		var inputBox = $('.search__input');
		var isOpen = false;
		submitIcon.click(function(e){
			e.preventDefault();
			if(isOpen == false){
				searchBox.parent('.search').addClass('open');
				searchBox.addClass('open');
				$(this).children('i').toggleClass('fa-search fa-times-circle');
				inputBox.focus();
				isOpen = true;
			} else {
				searchBox.parent('.search').removeClass('open');
        searchBox.removeClass('open');
				$(this).children('i').toggleClass('fa-search fa-times-circle');
				inputBox.focusout();
				isOpen = false;
			}
		});  
		submitIcon.mouseup(function(){
			return false;
		});
		searchBox.mouseup(function(){
			return false;
		});
  }

  $( document ).ready(function() {
    if($('#search').length > 0) {
      showSearch();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/search.js